export default __webpack_public_path__ + "static/media/What-is-DDD.d194ea16.png";